import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dfd26e40"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "root",
  class: "raraya_name_color raraya_base"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "hide-mobile",
  style: {"text-align":"left"}
}, "ししゅうのいろ", -1))
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "scrolling-container" }
const _hoisted_5 = { class: "options-list color-options" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormOption = _resolveComponent("FormOption")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
            return (_openBlock(), _createBlock(_component_FormOption, {
              optionType: 'color',
              key: item.id,
              option: item,
              onClick: ($event: any) => (_ctx.onThreadClick(item)),
              isSelected: _ctx.currentSelection == item.id
            }, null, 8, ["option", "onClick", "isSelected"]))
          }), 128))
        ])
      ])
    ])
  ], 512))
}